var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-full",on:{"click":_vm.handlerClick}},[_c('md-button',{staticClass:"width-full"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }